import { FC, MouseEvent, ReactNode } from 'react'
import { useClickAway } from '@uidotdev/usehooks'
import { Nav } from 'rsuite'
import CheckIcon from '@rsuite/icons/Check'

export type TContextMenuCurrentItem = {
    id: string,
    label: string,
}
export interface ContextMenuProps {
    x: number,
    y: number,
    visible: boolean,
    closeMenu: () => void,
    children: ReactNode,
}
export interface ContextMenuItemProps {
    onClick: (event: MouseEvent<HTMLElement>, item: TContextMenuCurrentItem) => void,
    currentItem: TContextMenuCurrentItem,
    /** set for an option that is on or off */
    checked?: boolean,
    children: ReactNode,
}

export const ContextMenu: FC<ContextMenuProps> = ({ x, y, visible, closeMenu, children }) => {
    const contextMenuRef = useClickAway<HTMLDivElement>(() => {
        closeMenu()
    })

    if (!visible) return null

    return (
        <div
            ref={contextMenuRef}
            className="context-menu"
            style={{ top: `${y}px`, left: `${x}px` }}
            onClick={closeMenu}
        >
            <Nav vertical>
                {children}
            </Nav>
        </div>
    )
}

export const ContextMenuItem: FC<ContextMenuItemProps> = ({ onClick, currentItem, checked, children }) => {
    const toggle = checked !== undefined
    return (
        <Nav.Item
            className="context-menu-item"
            role={toggle ? 'menuitemcheckbox' : undefined}
            aria-checked={toggle ? checked : undefined}
            onClick={(e) => onClick(e, currentItem)}
        >
            {toggle && <CheckIcon className="context-menu-check" style={{ visibility: checked ? 'visible' : 'hidden' }} />}
            {children}
        </Nav.Item>
    )
}